import { DatoCmsUniqueBanner } from 'lib/datoCms/types';
import { PROVENIENCE_QUERY_PARAM, isHappybetSite } from 'utility/constant';
import { DatoCmsGamesPage } from 'lib/types/page';
import { PROMO_MODEL_API_KEY } from 'lib/datoCms/constants';
import { SitemapPage } from 'lib/promoEngine/types';
import { isMatch } from 'utility/functions';

const doFilter = <T>(list: Array<T & { _modelApiKey: string }>, key: string): Array<T> =>
  list.filter((component) => component?._modelApiKey === key);

export function generateSiteMapPageByPageTop(page: DatoCmsGamesPage): SitemapPage {
  let { slug, heroBanner, visualComposer, bannerInsideList } = page ?? {};

  heroBanner = heroBanner ?? [];
  heroBanner.push({} as DatoCmsUniqueBanner);
  const [{ _modelApiKey: heroBannerApiKey }] = heroBanner;

  bannerInsideList = bannerInsideList ?? [];
  bannerInsideList.push({} as DatoCmsUniqueBanner);
  const [{ _modelApiKey: bannerInsideListApiKey }] = bannerInsideList;

  return {
    slug,
    heroBanners: heroBannerApiKey === PROMO_MODEL_API_KEY,
    pageBanners: doFilter(visualComposer ?? [], PROMO_MODEL_API_KEY).length,
    portraitBanner: bannerInsideListApiKey === PROMO_MODEL_API_KEY,
  };
}

export function generateSiteMapPageByPageCategory<T>(page: DatoCmsGamesPage | (DatoCmsGamesPage & T)): SitemapPage {
  let { slug, heroBanner, bannerOnPage, bannerInsideList } = page ?? {};

  heroBanner = heroBanner ?? [];
  heroBanner.push({} as DatoCmsUniqueBanner);
  const [{ _modelApiKey: heroBannerApiKey }] = heroBanner;

  bannerOnPage = bannerOnPage ?? [];
  bannerOnPage.push({} as DatoCmsUniqueBanner);
  const [{ _modelApiKey: bannerOnPageApiKey }] = bannerOnPage;

  bannerInsideList = bannerInsideList ?? [];
  bannerInsideList.push({} as DatoCmsUniqueBanner);
  const [{ _modelApiKey: bannerInsideListApiKey }] = bannerInsideList;

  return {
    slug,
    heroBanners: heroBannerApiKey === PROMO_MODEL_API_KEY,
    pageBanners: bannerOnPageApiKey === PROMO_MODEL_API_KEY ? 1 : 0,
    portraitBanner: bannerInsideListApiKey === PROMO_MODEL_API_KEY,
  };
}

export const getPromoUrl = (url: string, slugProvenienza: string) => {
  if (url.includes('registrati') || url.includes('register')) {
    let localSlug = `${slugProvenienza}`;

    if (/^\?/.test(localSlug)) {
      localSlug = `&${localSlug.substring(1)}`;
    } else if (/\?/.test(localSlug)) {
      localSlug = localSlug.replace('?', '&');
    }

    return `${url}?${PROVENIENCE_QUERY_PARAM}=${`${isHappybetSite ? 'newhpybet_' : 'newsnai_'}${localSlug}`}`;
  }

  return `/login?urlSuccess=${encodeURIComponent(url)}&urlClose=${encodeURIComponent(slugProvenienza)}`;
};

const extractDomain = (hostname: string) => {
  const parts = hostname.split('.');
  return parts.length > 1 ? parts[1] : parts[0];
};

export const getTargetType = (url: string): '_blank' | '_self' => {
  let isSameDomain = false;

  if (url?.length > 0 && url[0] === '/') {
    isSameDomain = true;
  }

  if (!isSameDomain && isMatch(url, '^http')) {
    const urlDomain = new URL(url).hostname;
    const urlDomainPart = extractDomain(urlDomain).toLowerCase();
    const currentDomainPart = extractDomain(`${process.env.NEXT_PUBLIC_BASE_URL}`).toLowerCase();
    isSameDomain = currentDomainPart === urlDomainPart;
  }

  return isSameDomain ? '_self' : '_blank';
};

export const filterBannerUniqueByModelApiKey = doFilter;
export const filterVisualComposerByModelApiKey = doFilter;
